<template>
  <div class="printTempComponent" :class="{hasBorder: showType !== 'print'}">
    <h2 class="reportAddress">{{report.report_title == '成都慈爱医院' ? '成都慈爱肿瘤医院' : report.report_title}}</h2>
    <h3 class="reportCate">{{report.device_category_name}}诊断报告</h3>
    <div class="patientInfo">
      <Row :gutter="24" class="patientInfoRow">
        <Col :span="8">
          <span>姓名：{{report.patient_name}}</span>
        </Col>
        <Col :span="9">
          <span>性别：{{report.sex? report.sex == 1? '男':'女':''}}</span>
        </Col>
        <Col :span="7">
          <span>年龄：{{report.age}}{{report.age_unit|getAgeUnit}}</span>
        </Col>
      </Row>
      <Row :gutter="24">
        <Col :span="8">
          <span>检查时间：{{report.check_datetime?report.check_datetime.substring(0, 10): ''}}</span>
        </Col>
        <Col :span="9">
          <span>报告单号：{{report.report_code}}</span>
        </Col>
        <Col :span="7">
          <span>影像号：{{report.matched_film_no}}</span>
        </Col>
      </Row>
    </div>
    <Row :gutter="24" class="checkInfo">
      <Col :span="8">
        <span>检查项目：{{report.device_category_name}}</span>
      </Col>
      <Col :span="16" class="checkBody">
        <span class="labelText">检查部位：</span>
        <span class="bodyContent" id="bodyContent">{{report.check_item_name}}</span>
      </Col>
    </Row>
    <!-- 影像表现 -->
    <div class="performe">
      <div class="labelTitle">
        <span>影像表现：</span>
      </div>
      <div class="printResult" id="reportRepresent" :class="{bitSmall: performeFontSize.bitSmall, small: performeFontSize.small}">{{report.image_representation}}</div>
    </div>
    <!-- 影像诊断 -->
    <div class="performe">
      <div class="labelTitle">
        <span>影像诊断：</span>
      </div>
      <div class="printResult" id="reportDiagnose" :class="{bitSmall: diagnoseFontSize.bitSmall, small: diagnoseFontSize.small}">{{report.diagnostic_result}}</div>
    </div>
    <!-- 医生签名 -->
    <Row :gutter="24" class="doctorSign">
      <Col :span="12">
        <label>报告医师：</label>
        <span v-if="showType !== 'print'">{{report.report_write_doctor_name | changeDoctorName('write')}}</span>
        <img v-if="showType === 'print' && report.reportDoctorInfo && report.reportDoctorInfo.write_doctor && report.reportDoctorInfo.write_doctor.signature_image_url" :src="report.reportDoctorInfo.write_doctor.signature_image_url" :alt="report.reportDoctorInfo.write_doctor.name"/>
        <span v-if="showType === 'print' && report.reportDoctorInfo && !report.reportDoctorInfo.write_doctor.signature_image_url">{{report.reportDoctorInfo.write_doctor.name}}</span>
      </Col>
      <Col :span="12">
        <label>审核医师：</label>
        <span v-if="showType !== 'print'">{{report.report_review_doctor_name | changeDoctorName('check')}}</span>
        <img v-if="showType === 'print' && report.reportDoctorInfo && report.reportDoctorInfo.review_doctor && report.reportDoctorInfo.review_doctor.signature_image_url" :src="report.reportDoctorInfo.review_doctor.signature_image_url" :alt="report.reportDoctorInfo.review_doctor.name"/>
        <span v-if="showType === 'print' && report.reportDoctorInfo && !report.reportDoctorInfo.review_doctor.signature_image_url">{{report.reportDoctorInfo.review_doctor.name}}</span>
        <div class="reportDate">报告日期：{{report.report_review_finish_time?report.report_review_finish_time.substring(0, 10): ''}}</div>
      </Col>
    </Row>
    <!-- 注意（打印显示） -->
    <div class="reportTip">
      <span>注：本报告仅供临床医师参考</span>
    </div>
  </div>
</template>
<script>
import { Row, Col } from 'ant-design-vue'
export default {
  components: {
    Col,
    Row
  },
  props: {
    report: {
      type: Object,
      default: () => ({})
    },
    showType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      diagnoseFontSize: {
        bitSmall: false,
        small: false
      },
      performeFontSize: {
        bitSmall: false,
        small: false
      }
    }
  },
  mounted () {
    if (this.showType === 'print' && this.report && this.report.image_representation) {
      let imageRepresentationLen = this.report.image_representation.length
      let diagnosResultLen = this.report.diagnostic_result.length
      if (imageRepresentationLen > 400 && imageRepresentationLen < 550) {
        this.performeFontSize.bitSmall = true
      } else if (imageRepresentationLen >= 550) {
        this.performeFontSize.small = true
      }
      if (diagnosResultLen > 400 && diagnosResultLen < 550) {
        this.diagnoseFontSize.bitSmall = true
      } else if (diagnosResultLen >= 550) {
        this.diagnoseFontSize.small = true
      }
    }
    let bodyContentDom = document.getElementById('bodyContent')
    if (bodyContentDom && bodyContentDom.offsetHeight) {
      let height = parseInt(bodyContentDom.offsetHeight, 10)
      if (height > 30) {
        let reportDiagnose = document.getElementById('reportDiagnose')
        if (reportDiagnose) {
          reportDiagnose.style.minHeight = `${400 - height - 30}px`
        }
      }
    }
  }
}
</script>
<style lang="less">
@import url('../../style/common/variable.less');
.printTempComponent{
  color:#000;
  width: 21cm;
  margin: 0 auto;
  background-color: @baseColor;
  font-size:@middleFontSize;
  font-weight: 400;
  font-family: 'PingFangSC-Regular, sans-serif' !important;
  font-size: 18px;
  .reportAddress{
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    margin-bottom: 0;
    color:#000;
  }
  .reportCate{
    text-align: center;
    font-size: 26px;
    text-align: center;
    margin: 10px 0 20px 0;
    font-weight: 700;
    color:#000;
  }
  .patientInfo{
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    padding: 15px 0;
    .patientInfoRow{
      padding-bottom: 15px;
    }
  }
  .checkInfo{
    padding: 10px 0 15px 0;
    .checkBody{
      display: flex;
      .bodyContent{
        flex:1;
      }
    }
  }
  .performe{
    .labelTitle{
      display: flex;
      justify-content: space-between;
      .remainder{
        justify-self: flex-end;
      }
    }
  }
  .printResult{
    border:none;
    min-height: 340px;
    max-height: 340px;
    overflow: auto;
    text-align: left;
    white-space: pre-wrap;
    line-height: 1.5;
    margin-left: 18px;
    margin-top:15px;
  }
  .doctorSign{
    img{
      background: #fff;
      width: 130px;
      height: 55px;
      vertical-align: middle;
      object-fit: cover;
    }
  }
  .reportTip{
    border-top:1px solid #000;
    padding-top: 10px;
  }
  .reportDate{
    padding-bottom: 10px;
  }
  .bitSmall{
    font-size: 17px;
  }
  .small{
    font-size: 15px;
  }
}
.hasBorder{
  padding: 0 30px 60px 30px;
  border: 1px solid @divideLineColor;
}
</style>